// src/components/UI/InsightCard.jsx (CORRIGIDO)
import React from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { AiOutlineBulb } from 'react-icons/ai'; 

const InsightCard = ({ text }) => {
  return (
    <Flex
      p={4}
      bg="surface"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.800"
      align="flex-start" // Alinha o conteúdo ao topo se o texto for longo
    >
      <Icon as={AiOutlineBulb} color="yellow.400" mr={4} w={6} h={6} />
      <Text 
        fontSize="sm" 
        color="gray.300"
        dangerouslySetInnerHTML={{ __html: text }} 
      />
    </Flex>
  );
};

export default InsightCard;